export default __webpack_public_path__ + "static/media/Top 100 logo-01.1e03991f.svg";